import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Select } from '@ngxs/store';
import { TenantDataService } from 'app/config/services/tenant-data.service';
import { CommunityUserDetailsComponent } from 'app/library/community-user/components/dialog/user-details/user-details.component';
import { ExperienceAlumniWidgetContent } from 'app/library/grow/models/experience-alumni-widget-content.model';
import { ExperienceConfig } from 'app/library/grow/models/experience-config.model';
import { User } from 'app/projects/user/src/lib/models/user';
import { UserState } from 'app/projects/user/src/lib/models/user.state';
import { GeneralAnalyticsService } from 'app/services/general-analytics.service';
import { TalkService } from 'app/services/talk.service';
import { Observable, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { SwiperOptions } from 'swiper/types/swiper-options';

@Component({
    selector: 'app-alumni-swipper',
    templateUrl: './alumni-swipper.component.html',
    styleUrls: ['./alumni-swipper.component.scss'],
})
export class AlumniSwipperComponent implements OnInit {
    @Select(UserState.getMyInfo)
    profile$: Observable<User>;
    profileSubscription$: Subscription;
    profile: User;

    @ViewChild('swiperEl', { static: false }) swiperEl!: ElementRef;

    public swiperConfig: SwiperOptions = {
        a11y: { enabled: true },
        direction: 'horizontal',
        slidesPerView: 'auto',
        keyboard: false,
        mousewheel: false,
        scrollbar: false,
        pagination: false,
        spaceBetween: 8,
        updateOnWindowResize: true,
        breakpoints: {
            // when window width is >= 1280px
            1280: {
                slidesPerView: 4,
                slidesPerGroup: 4,
            },
            1340: {
                slidesPerView: 5,
                slidesPerGroup: 5,
            },
            1560: {
                slidesPerView: 6,
                slidesPerGroup: 6,
            },
            1760: {
                slidesPerView: 7,
                slidesPerGroup: 7,
            },
        },
        navigation: {
            prevEl: '.alumni-swiper-button-prev',
            nextEl: '.alumni-swiper-button-next',
        },
    };

    @Input()
    experienceAlumniWidget: ExperienceAlumniWidgetContent;

    @Input()
    experienceConfig: ExperienceConfig;

    constructor(
        private _matDialog: MatDialog,
        private _router: Router,
        private _locationBasedAnalyticsService: GeneralAnalyticsService,
        public tenantDataService: TenantDataService,
        public http: HttpClient,
        public talkService: TalkService
    ) {}

    ngOnInit(): void {
        this.profileSubscription$ = this.profile$.pipe(filter((profile) => !!profile)).subscribe((profile) => {
            this.profile = profile;
        });
    }

    ngAfterViewInit(): void {
        Object.assign(this.swiperEl.nativeElement, this.swiperConfig);
        this.swiperEl.nativeElement.initialize();

        const swiperContainer = this.swiperEl.nativeElement.shadowRoot.querySelector('.swiper') as HTMLElement;
        if (swiperContainer) {
            swiperContainer.style.overflow = 'visible';
        }
    }

    async openUserDetailsDialog(user: User): Promise<void> {
        const dialogRef = this._matDialog.open(CommunityUserDetailsComponent, {
            width: '540px',
        });

        dialogRef.componentInstance.onStartConversationEvent.subscribe(async (user: User) => {
            if (user) {
                await this.talkService.startConversationByUser(user, 'new_sidebar');
                dialogRef.close();
            }
        });

        dialogRef.componentInstance.myProfile = this.profile;
        dialogRef.componentInstance.user = user;
        if (this._router.url === '/grow') {
            this._locationBasedAnalyticsService.createAlumniWidgetEvent('engage_alumni_widget_clicked', user.id, this.experienceAlumniWidget.id, this.experienceAlumniWidget.name);
        }
    }

    ngOnDestroy() {
        this.profileSubscription$.unsubscribe();
    }
}
